import { isEqual } from "lodash";

import store from "./store";

const SEARCH_VISITED_KEY = "searchVisitedItems";
const SEARCH_SEARCHES_KEY = "searchFullTexts";

type StreamExtra = { type: "personal"; isShared: boolean } | { type: "meeting" | "oneonone" };

export type StreamVisitedItem = StreamExtra & {
	version: 2;
	id: string;
	url: string;
	displayName: string;
	name?: string;
	otherUser?: {
		id: string;
	};
};

export type VisitedItem = StreamVisitedItem;

export interface SavedData {
	visited: VisitedItem[];
	searches: string[];
}

export function removeVisitedItem(index: number) {
	const savedVisitedItems: VisitedItem[] = store.get(SEARCH_VISITED_KEY, []);
	if (index >= savedVisitedItems.length) {
		return;
	}

	savedVisitedItems.splice(index, 1);
	store.set(SEARCH_VISITED_KEY, savedVisitedItems);
}

export function removeSavedSearch(index: number) {
	const searchesList: string[] = store.get(SEARCH_SEARCHES_KEY, []);
	if (index >= searchesList.length) {
		return;
	}

	searchesList.splice(index, 1);
	store.set(SEARCH_SEARCHES_KEY, searchesList);
}

export function saveRecentSearch(value: string) {
	const searchesList: string[] = store.get(SEARCH_SEARCHES_KEY, []).filter((item: string) => item !== value);

	if (searchesList.length >= 5) {
		searchesList.pop();
	}

	searchesList.unshift(value);
	store.set(SEARCH_SEARCHES_KEY, searchesList);
}

export function saveVisitedItem(item: VisitedItem) {
	const savedVisitedItems: VisitedItem[] = store
		.get(SEARCH_VISITED_KEY, [])
		.filter((i: VisitedItem) => !isEqual(i.url, item.url));

	if (savedVisitedItems.length >= 5) {
		savedVisitedItems.pop();
	}

	savedVisitedItems.unshift(item);
	store.set(SEARCH_VISITED_KEY, savedVisitedItems);
}

export function removeVisitedItemWithUrl(url: string) {
	const savedVisitedItems: VisitedItem[] = store.get(SEARCH_VISITED_KEY, []).filter((i: VisitedItem) => i.url !== url);
	store.set(SEARCH_VISITED_KEY, savedVisitedItems);
}

export function getSavedData(): SavedData {
	return {
		visited: store.get(SEARCH_VISITED_KEY, []),
		searches: store.get(SEARCH_SEARCHES_KEY, []),
	};
}
